var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "big-figure", class: _vm.classObject }, [
    _c("div", { staticClass: "big-figure__body" }, [
      _c("div", { staticClass: "big-figure__card" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _c("div", { staticClass: "big-figure__image" }, [
        _vm.image
          ? _c("div", {
              staticClass: "big-figure__image-bg",
              style: "background-image: url(" + _vm.image + ");",
            })
          : _c("div", {
              staticClass: "big-figure__image-bg big-figure__image-bg--dummy",
            }),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }